import { Hammer, Lightbulb, UtensilsCrossed, Moon, HandHeart, Bath, Pause, HeartHandshake, Building2, Puzzle } from "lucide-react";

export const DESIGN_STATUSES = [
  { key: "WORKING", label: "Working", icon: Hammer, cls: "bg-emerald-500 text-white", soft: "bg-emerald-50 text-emerald-700" },
  { key: "BRAINSTORMING", label: "Brainstorm", icon: Lightbulb, cls: "bg-violet-500 text-white", soft: "bg-violet-50 text-violet-700" },
  { key: "HELP", label: "Help Team", icon: HeartHandshake, cls: "bg-pink-500 text-white", soft: "bg-pink-50 text-pink-700" },
  { key: "OFFICE", label: "Kegiatan Kantor", icon: Building2, cls: "bg-cyan-600 text-white", soft: "bg-cyan-50 text-cyan-700" },
  { key: "ASSEMBLY", label: "Assembly", icon: Puzzle, cls: "bg-lime-600 text-white", soft: "bg-lime-50 text-lime-700" },
  { key: "LUNCH", label: "Lunch", icon: UtensilsCrossed, cls: "bg-orange-500 text-white", soft: "bg-orange-50 text-orange-700" },
  { key: "DINNER", label: "Dinner", icon: Moon, cls: "bg-indigo-500 text-white", soft: "bg-indigo-50 text-indigo-700" },
  { key: "PRAY", label: "Pray", icon: HandHeart, cls: "bg-teal-500 text-white", soft: "bg-teal-50 text-teal-700" },
  { key: "TOILET", label: "Toilet", icon: Bath, cls: "bg-sky-500 text-white", soft: "bg-sky-50 text-sky-700" },
  { key: "PAUSE", label: "Pause", icon: Pause, cls: "bg-slate-500 text-white", soft: "bg-slate-100 text-slate-700" },
  { key: "VOID", label: "Void Time", icon: Pause, cls: "bg-rose-700 text-white", soft: "bg-rose-50 text-rose-700", hidden: true },
];
export const WORK_KEYS = ["WORKING", "BRAINSTORMING"];
export const SPECIAL_KEYS = ["HELP", "OFFICE", "ASSEMBLY"];
export const statusMeta = (k) => DESIGN_STATUSES.find((s) => s.key === k) || DESIGN_STATUSES.find((s) => s.key === "PAUSE");

export const fmtDur = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};
export const fmtHM = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  return `${Math.floor(s / 3600)}j ${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}m`;
};

export const refreshDesign = () => window.dispatchEvent(new Event("design-refresh"));
export const openDesignPip = () => window.dispatchEvent(new CustomEvent("design-open-pip", { detail: { silent: true } }));
